import React from "react";
import { Stack, Typography } from "@mui/material";

export default function ContactEnrollmentResults({ result }) {
  if (!result) return null;
  return (
    <Stack spacing={1} mt={2}>
      <Typography variant="subtitle2">Enrollment details</Typography>
      {result.results.map((item, index) => (
        <Typography key={item.contact?.id || index} variant="body2">
          {item.contact?.email || "Unknown contact"}: {item.message}
        </Typography>
      ))}
    </Stack>
  );
}
